import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "CalendarUnifiedTelemetryUtils" */ './lazyIndex'),
    { name: 'CalendarUnifiedTelemetryUtils' }
);

export const lazyCreateOpenEventUnifiedEventFromMeetingRequest: LazyImport<
    typeof lazyIndex.createOpenEventUnifiedEventFromMeetingRequest,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.createOpenEventUnifiedEventFromMeetingRequest);

export const lazyLogCalendarPlanModeEvent: LazyAction<
    typeof lazyIndex.logCalendarPlanModeEvent,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logCalendarPlanModeEvent);

export const lazyLogPlanModeOperationEdit: LazyAction<
    typeof lazyIndex.logPlanModeOperationEdit,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logPlanModeOperationEdit);

export const lazyLogPlanModeCommit: LazyAction<
    typeof lazyIndex.logPlanModeCommit,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logPlanModeCommit);

export const lazyLogOrganizeEntryPointShown: LazyAction<
    typeof lazyIndex.logOrganizeEntryPointShown,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logOrganizeEntryPointShown);

export const lazyLogOrganizeEntryPointClick: LazyAction<
    typeof lazyIndex.logOrganizeEntryPointClick,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logOrganizeEntryPointClick);

// Direct exports for types only (no runtime code = zero bundle impact)
export type {
    PlanModeData,
    PlanModeEventOptions,
    PlanModeCommitFailureBreakdown,
} from './utils/planModeDataTypes';
export type {
    OrganizeEntryPoint,
    OrganizeEntryPointClickTelemetryOptions,
} from './utils/logOrganizeEntryPointTelemetry';
export type { PlanModeOperationEditOptions } from './utils/logPlanModeOperationEdit';
export type {
    PlanModeCommitSummary,
    PlanModeCommitOptions,
} from './utils/logPlanModeCommitTelemetry';
export type {
    MeetingBriefingTelemetryData,
    MeetingBriefingEntrypointContext,
} from './utils/logMeetingBriefingUserAction';
